import { motion } from "framer-motion";
import { LadderVisual } from "./LadderVisual";
import { SignupCard } from "./SignupCard";

const headlineLines = ["The Word-Breakdown Tool", "for Modern English Teachers"];

const invitationParagraphs = [
  "This web-app is designed to help you guide your students to break down difficult words visually, so you can guide them from confusion to confidence using Drew’s Sound Ladder method.",
];

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative flex min-h-[100vh] w-full flex-col items-center justify-center overflow-hidden px-4 pt-28 pb-20 sm:px-8"
    >
      <LadderVisual />

      <motion.span
        data-testid="hero-eyebrow"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="font-mono-accent mb-6 inline-flex items-center gap-2 rounded-full border border-sky-200 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-sky-700 backdrop-blur-sm"
      >
        <span className="soft-pulse h-1.5 w-1.5 rounded-full bg-sky-500" />
        Drew’s Sound Ladder Method
      </motion.span>

      <h1 className="font-display max-w-4xl pb-[16px] text-center text-4xl font-extrabold leading-[1.4] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
        {headlineLines.map((line, i) => (
          <span key={line} className="block overflow-hidden pb-[0.15em]">
            <motion.span
              className="block pb-[0.15em]"
              custom={i}
              initial="hidden"
              animate="visible"
              variants={lineVariants}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h1>

      <motion.p
        data-testid="hero-method"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
        className="font-display mx-auto mt-6 max-w-2xl text-center text-lg font-bold tracking-tight text-sky-700 sm:text-xl"
      >
        Powered by Coach Drew Sisera’s Sound Ladder Method.
      </motion.p>

      <motion.div
        data-testid="hero-invitation"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-body mx-auto mt-5 max-w-2xl space-y-4 text-center text-base font-light leading-[1.8] text-slate-500 sm:text-lg sm:leading-[1.85]"
      >
        {invitationParagraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </motion.div>

      <motion.p
        data-testid="hero-cta-line"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.85, ease: [0.22, 1, 0.36, 1] }}
        className="font-body mx-auto mt-6 max-w-lg text-center text-sm font-medium text-slate-600 sm:text-base"
      >
        Join the Free Beta List below. We’ll notify you via email or WhatsApp as soon
        as we’re live.
      </motion.p>

      <div className="mt-8 w-full">
        <SignupCard />
      </div>
    </section>
  );
};
